let language = {
ADD_STORE_PRODUCT_MODAL_SETECT_STORE_TITLE:"Add product to store",
ADD_STORE_PRODUCT_MODAL_SETECT_STORE_CANCEL_BTN:"Cancel",
ADD_STORE_PRODUCT_MODAL_SETECT_STORE_NEXT_BTN:"Next"
};

export { language }